<template>
    <v-content v-if="! isLogged">
        <v-container fluid grid-list>
            <v-layout row align-center justify-center mt-4>
                <v-flex xs3 sm3 md3>
                  <img :src="BASE_ASSETS + logo" style="height: 100%">
                </v-flex>
            </v-layout>
            <v-layout row align-center justify-center mt-3>
                <v-flex xs12 sm12 md12>
                    <p class="display-1 text-xs-center">Enter new password</p>
                </v-flex>
            </v-layout>

            <v-layout row align-center justify-center mt-3>
                <v-flex xs12 sm6>
                    <form @submit.prevent="update">
                        <v-text-field
                                type="password"
                                v-validate="'required'"
                                v-model="data.password"
                                :error-messages="errors.collect('data.password')"
                                label="Password"
                                data-vv-name="data.password"
                                ref="password"
                        ></v-text-field>
                        <v-text-field
                                type="password"
                                v-validate="'required|confirmed:password'"
                                label="Repeat password"
                                name="confirmation"
                                data-vv-as="password"
                                data-vv-name="data.password"
                                v-model="data.confirmation"
                        ></v-text-field>
                        <v-btn large color="secondary" class="text--primary" type="submit">Save</v-btn>
                    </form>

                    <v-flex xs12>
                      <v-alert
                              v-if="error"
                              :value="true"
                              color="error"
                              icon="warning"
                              outline
                      >
                        <ul style="list-style: none;">
                          <li v-for="message in message_error">
                            {{ message }}
                          </li>
                        </ul>
                      </v-alert>
                  </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>

    import { BASE_ASSETS } from  '../../../config';

    export default {
        props: ['token'],
        $_veeValidate: {
            validator: 'new'
        },
        data : function() {
            return {
                data : {},
                BASE_ASSETS: BASE_ASSETS,
                error : false,
                message_error : []
            }
        },
        created () {
            this.data.token = this.token;
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods : {
            update : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.$store.dispatch('resetPassword', this.data).then((res) => {
                            this.$router.push({ name: 'login' });
                        }).catch((error) => {
                          console.log(error);

                          this.message_error = [];

                          if(error.status == 422){
                            for(var i in error.data.errors){
                              for(var j in error.data.errors[i]){
                                this.message_error.push(error.data.errors[i][j]);
                              }
                            }
                          }else{
                            this.message_error.push(error.data.message);
                          }


                          this.error = true;


                        });
                    }
                });
            }
        },
        computed : {
            isLogged : function(){
                return this.$store.getters.isLogged;
            },
            logo () {
                return require('@/assets/logo.png')
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shared/reset_password/ResetPasswordComponent.vue